import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { ReloadOutlined } from '@ant-design/icons';

import { Row, Col, Table, Button, Upload, notification } from 'antd';

import DivisionDetailActions from '../../Stores/DivisionDetail/Actions';

class TxnFlowTable extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      fileList: []
    };

    this.getDocumentColumns = this.getDocumentColumns.bind(this);
    this.useOnUpload = this.useOnUpload.bind(this);
    this.useOnDownload = this.useOnDownload.bind(this);
  }

  componentDidMount() {
    const { resetInvTxnFlowTimestamp } = this.props;

    resetInvTxnFlowTimestamp();
  }

  componentDidUpdate(prevProps) {
    const { resId, showInvTxnFlows, showInvTxnFlowsSuccess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('invTxnFlowTimestamp')) {
      if (resId === 0) {
        showInvTxnFlowsSuccess([]);
      } else {
        showInvTxnFlows(resId);
      }
    }
  }

  componentWillUnmount() {}

  getDocumentColumns() {
    const { intl } = this.props;

    return [
      {
        width: 100,
        align: 'left',
        title: intl.formatMessage({ id: 'flow' }),
        // sort field
        dataIndex: 'str_txn_flow_type',
        // filter field
        key: 'str_txn_flow_type',
        render: (text, record) => <>{record.str_txn_flow_type}</>
      },
      {
        width: 50,
        align: 'right',
        title: intl.formatMessage({ id: 'step' }),
        // sort field
        dataIndex: 'step',
        // filter field
        key: 'step',
        render: (text, record) => <>{record.step}</>
      },
      {
        width: 300,
        align: 'left',
        title: intl.formatMessage({ id: 'process' }),
        // sort field
        dataIndex: 'str_proc_type',
        // filter field
        key: 'str_proc_type',
        render: (text, record) => (
          <>{intl.formatMessage({ id: `${record.str_proc_type.toLowerCase()}_desc` })}</>
        )
      },
      {
        width: 50,
        align: 'right',
        title: intl.formatMessage({ id: 'mode' }),
        // sort field
        dataIndex: 'scan_mode',
        // filter field
        key: 'scan_mode',
        render: (text, record) => <>{record.scan_mode}</>
      }
    ];
  }

  useOnUpload() {
    const { resId, uploadExcel } = this.props;
    const { fileList } = this.state;

    if (fileList.length > 0) {
      uploadExcel(resId, fileList[0]);
    }
  }

  useOnDownload() {
    const { resId, downloadExcel } = this.props;

    downloadExcel(resId);
  }

  render() {
    const {
      intl,
      resetInvTxnFlowTimestamp,
      resId,
      invTxnFlows,
      invTxnFlowsIsLoading,
      uploadIsLoading
    } = this.props;
    const { fileList } = this.state;

    return (
      <>
        <Table
          size="small"
          // rowSelection={rowSelection}
          rowKey="proc_type"
          pagination={false}
          columns={this.getDocumentColumns()}
          dataSource={invTxnFlows}
          loading={invTxnFlowsIsLoading}
          bordered
          title={() => (
            <>
              <Row type="flex" justify="start" gutter={[0, 16]}>
                <Col span={1}>
                  <Button
                    type="primary"
                    // disabled={!isValid}
                    loading={invTxnFlowsIsLoading}
                    onClick={() => resetInvTxnFlowTimestamp()}
                    icon={<ReloadOutlined />}
                  />
                </Col>
                <Col span={8}>
                  <Upload
                    disabled={false}
                    onRemove={() => {
                      this.setState({
                        fileList: []
                      });
                    }}
                    beforeUpload={file => {
                      const validFileName = 'INV_TXN_FLOW';
                      if (file && file.name.toLowerCase().includes(validFileName.toLowerCase())) {
                        this.setState({
                          fileList: [file]
                        });
                      } else {
                        notification.error({
                          message: `${intl.formatMessage({
                            id: 'invalid_file_name_must_contain'
                          })} ${validFileName}`,
                          duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
                        });
                      }

                      return false;
                    }}
                    fileList={fileList}
                  >
                    <Button type="primary" disabled={false} loading={invTxnFlowsIsLoading}>
                      {intl.formatMessage({ id: 'browse' })}
                    </Button>
                  </Upload>
                </Col>
                <Col span={6}>
                  <Button
                    type="primary"
                    onClick={this.useOnUpload}
                    disabled={fileList.length === 0}
                    loading={uploadIsLoading}
                  >
                    {intl.formatMessage({ id: 'upload' })}
                  </Button>
                  <Button
                    type="primary"
                    disabled={invTxnFlowsIsLoading || resId === 0}
                    onClick={this.useOnDownload}
                    loading={uploadIsLoading}
                  >
                    {intl.formatMessage({ id: 'download' })}
                  </Button>
                </Col>
              </Row>
            </>
          )}
          // scroll={{ x: 950 }}
        />
      </>
    );
  }
}

TxnFlowTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  resetInvTxnFlowTimestamp: PropTypes.func,
  showInvTxnFlows: PropTypes.func,
  showInvTxnFlowsSuccess: PropTypes.func,
  resId: PropTypes.number,
  invTxnFlowsIsLoading: PropTypes.bool,
  invTxnFlows: PropTypes.arrayOf(PropTypes.object),

  uploadIsLoading: PropTypes.bool,
  uploadExcel: PropTypes.func,
  downloadExcel: PropTypes.func
};

TxnFlowTable.defaultProps = {
  intl: {},
  resetInvTxnFlowTimestamp() {},
  showInvTxnFlows() {},
  showInvTxnFlowsSuccess() {},
  resId: 0,
  invTxnFlows: [],
  invTxnFlowsIsLoading: false,

  uploadIsLoading: false,
  uploadExcel() {},
  downloadExcel() {}
};

const mapStateToProps = state => ({
  invTxnFlowTimestamp: state.divisionDetail.invTxnFlowTimestamp,
  resId: state.divisionDetail.resId,
  invTxnFlows: state.divisionDetail.invTxnFlows,
  invTxnFlowsIsLoading: state.divisionDetail.invTxnFlowsIsLoading,

  uploadIsLoading: state.divisionDetail.invTxnFlowsUploadIsLoading
});

const mapDispatchToProps = dispatch => ({
  resetInvTxnFlowTimestamp: () =>
    dispatch(DivisionDetailActions.divisionDetailResetInvTxnFlowTimestamp()),
  showInvTxnFlows: resId => dispatch(DivisionDetailActions.divisionDetailShowInvTxnFlows(resId)),
  showInvTxnFlowsSuccess: txnFlows =>
    dispatch(DivisionDetailActions.divisionDetailShowInvTxnFlowsSuccess(txnFlows)),

  uploadExcel: (resId, file) =>
    dispatch(DivisionDetailActions.divisionDetailInvTxnFlowsUploadExcel(resId, file)),
  downloadExcel: resId =>
    dispatch(DivisionDetailActions.divisionDetailInvTxnFlowsDownloadExcel(resId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TxnFlowTable));
